import React, { Component } from 'react';
import $ from "jquery";

import "./../styles/formTextItem.css";

export default class PagConozcoAlguien extends Component {
    componentDidMount(){
        $(".seccion h3").click(function(){
            if($(this).siblings(".secContenido").height() > 0){
                $(this).siblings(".secContenido").animate({"height": "0px"}, {
                    easing: "linear",
                    duration: "150"
                });
            }
            else{
                const elementHeight = $(this).siblings(".secContenido").css({"height": "auto"}).height();
                $(this).siblings(".secContenido").css({"height": "0"});
                $(this).siblings(".secContenido").animate({"height": elementHeight + "px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        //setTimeout(()=>{$(this).siblings(".secContenido").css({"height": "auto"})}, 1000);
                        $(this).siblings(".secContenido").css({"height": "auto"})
                    }
                });
            }
            $(this).toggleClass("icon-plus");
            $(this).toggleClass("icon-minus");
        });
        $(".seccion h4").click(function(){
            if($(this).siblings(".secContenido").height() > 0){
                $(this).siblings(".secContenido").animate({"height": "0px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        $(this).siblings(".secContenido").css({"marginTop": "0px"})
                    }
                });
            }
            else{
                const elementHeight = $(this).siblings(".secContenido").css({"height": "auto"}).height();
                $(this).siblings(".secContenido").css({"height": "0"});
                $(this).siblings(".secContenido").css({"marginTop": "15px"})
                $(this).siblings(".secContenido").animate({"height": elementHeight + "px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        //setTimeout(()=>{$(this).siblings(".secContenido").css({"height": "auto"})}, 1000);
                        $(this).siblings(".secContenido").css({"height": "auto"})
                    }
                });
            }
            $(this).toggleClass("icon-plus");
            $(this).toggleClass("icon-minus");
        });

    }
    render() {
        return (
            <React.Fragment>
                <div className="card formTextItem">
                    <h1>Me preocupa alguien</h1>
                    <p className="description">
                        Acompañar a un familiar, un amigx, una pareja o una persona allegada que tiene pensamientos 
                        de suicidio siempre es duro y difícil. <br/>
                        Vamos a tratar de brindarte información para que puedas comprender más la situación y te 
                        sientas más orientadx sobre qué hacer y qué no hacer antes de un intento suicida y después 
                        de él (tanto en el hospital como al alta, o una vez de regreso a casa). 
                    </p>
                </div>

                <div className="card formTextItem">
                    <h1>¿Qué le esta pasando?</h1>
                    <p className="description">
                        El suicidio aparece como una forma de resolver un problema y poner fin a un dolor
                        que se experimenta como interminable, incontrolable e intolerable. No se ve luz
                        al final del túnel, se sienten solos, alejados, creen que nadie puede ayudarlos,
                        y de hecho sienten que son una molestia para los demás, una carga. Sienten que nunca
                        nada va a cambiar.<br/>
                        Es importante entender que aunque en el momento de crisis no lo parezca, estos sentimientos
                        de angustia, de desesperanza, de soledad y desesperación no duran para siempre. Las crisis
                        no son permanentes.
                    </p>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Sobre el suicidio</b></h4>
                        <div className="secContenido">
                            <ul>
                                <li>El suicidio NO es un problema individual que solo afecta a una persona, a una familia o a una comunidad.</li>
                                <li>De acuerdo con la Organización Mundial de la Salud, el suicidio es un grave problema de salud pública que resulta en casi 1 millón de muertes prevenibles al año.</li>
                                <li>En nuestro país es la segunda causa de fallecimiento de jóvenes entre 15 y 24 años.</li>
                                <li>Quienes más consuman el suicidio son los varones. Mientras que las mujeres lo intentan con más frecuencia.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card formTextItem">
                    <h1>Mitos sobre las personas con ideas sobre el suicidio</h1>
                    <p className="description">
                        En toda sociedad existen mitos sobre diferentes temas. Son creencias erróneas, falsas, que se 
                        transmiten como si fueran verdades científicas y que pueden tener graves consecuencias y 
                        dificultar la prevención de un intento suicido. Por eso, es fundamental desterrar estos mitos 
                        para poder comprender y ayudar a una persona con pensamientos sobre el suicidio:
                    </p>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Mito 1: Preguntar a una persona si está pensando en suicidarse, puede incitarle a hacerlo</b></h4>
                        <div className="secContenido">
                            <p>
                                Está demostrado que preguntar y hablar con la persona sobre la presencia de pensamientos 
                                suicidas, disminuye el riesgo de cometer el acto. Hablar siempre genera alivio en la persona 
                                que está sufriendo. <br />
                                Es muy importante acercarse con una actitud de comprensión y de escucha, para que sienta tu 
                                deseo de ayudar y tu preocupación. No intentes discutir o minimizar estas ideas. Dejalx 
                                hablar de lo que le pasa. 
                            </p>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Mito 2: La persona que expresa su deseo de acabar con su vida nunca lo hará</b></h4>
                        <div className="secContenido">
                            <p>
                                La gran mayoría de los casos en que las personas han intentado suicidarse, 
                                habían manifestado de alguna manera su intención de hacerlo con palabras, 
                                amenazas, gestos o cambios de conducta.<br/>
                                Estas verbalizaciones o gestos SIEMPRE indican que esa persona está sufriendo, necesita 
                                ayuda y no sabe cómo pedirla. Es muy importante que NUNCA sean consideradas como un 
                                simple llamado de atención, chantaje o manipulación de la persona para la obtención 
                                de un fin determinado.
                            </p>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Mito 3: La persona que se quiere suicidar no lo dice</b></h4>
                        <div className="secContenido">
                            <p>
                                Solamente un pequeño número de suicidios se produce sin aviso. De cada 10 personas 
                                que se suicidan, 9 lo expresaron claramente o dejaron entrever sus intenciones de 
                                acabar con su vida. <br/>
                                Todas las amenazas de autolesión deben ser tomadas en serio. Por eso, si detectás 
                                una señal de alerta directa o indirecta y creés que la persona que te preocupa se 
                                encuentra en una situación de riesgo, es importante que le preguntes sobre ello. 
                            </p>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Mito 4: El suicidio es impulsivo y la mayoría de los suicidas no avisa</b></h4>
                        <div className="secContenido">
                            <p>
                                El suicidio puede ser el resultado de un acto impulsivo repentino o de una planificación 
                                muy cuidadosa. En ambos casos, casi siempre existen señales directas o indirectas, 
                                mensajes, gestos que advierten el riesgo de un intento de suicidio.<br/>
                                Es erróneo pensar que no podemos hacer nada para prevenir la conducta suicida. 
                                El suicidio y/o sus intentos, en muchas ocasiones, se pueden prevenir y es por ello 
                                muy importante que aprendamos a detectar las señales de alerta de riesgo.
                            </p>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Mito 5: Solo las personas con problemas graves se suicidan</b></h4>
                        <div className="secContenido">
                            <p>
                                El suicidio es multicausal. Muchos problemas pequeños pueden llevar al suicidio. 
                                Nunca menosprecies ni compares. Lo que para algunos puede ser un problema simple 
                                o sin importancia, para otros  puede ser algo catastrófico.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card formTextItem">
                    <h1 className="noDescription">¿Como saber que esta atravesando una crisis?</h1>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Señales de alerta</b></h4>
                        <div class="secContenido">
                            <ul>
                                <li>Lx veo con mucha bronca, impotencia, vergüenza, tristeza.</li>
                                <li>Hace tiempo está pasando por una situación muy difícil y siente que ya no tiene salida.</li>
                                <li>Está consumiendo excesivamente alcohol o drogas.</li>
                                <li>Abandonó muchas actividades que le gustaba hacer.</li>
                                <li>No quiere estar con nadie, se encierra en sí mismo.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Señales de máximo riesgo</b></h4>
                        <div class="secContenido">
                            <ul>
                                <li>Me dijo que tiene pensamientos sobre suicidarse, de que su vida no vale la pena, que es una carga para los demás.</li>
                                <li>Dejó mensajes en las redes sociales sobre quitarse la vida o cartas de despedida.</li>
                                <li>De repente parece estar muy tranquilx cuando previamente había presentado una gran agitación.</li>
                                <li>Regaló muchas de sus cosas.</li>
                                <li>Se autolesiona (por ejemplo, cortes o quemaduras).</li>
                                <li>Tuvo un intento de suicidio.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="card formTextItem">
                    <h1>¿Qué puedo hacer?</h1>
                    <p className="description">
                        En primer lugar, es importante que sepas que a las personas que están atravesando estas crisis les es
                        muy difícil saber cómo pedir ayuda. Te damos algunos TIPS para facilitarte cómo acercarte a hablar y escuchar
                        a la persona que te preocupa:
                    </p>
                    <ul className="description" style={{padding: "10px 45px 20px 45px"}}>
                        <li>Es importante que te acerques con una actitud de ayuda y comprensión. Aunque te resulte difícil, tratá de no enojarte, ni asustarte mientras estén hablando, no juzgues ni des sermones sobre lo que pueda decir o hacer.</li>

                        <li>Conservar la calma. Transmitir tranquilidad, tanto con la comunicación verbal como corporal.</li>

                        <li>No desafiar, no despreciar, minimizar, ni desoír las amenazas. </li>

                        <li>No repetir frases hechas ni dar consejos simplistas (por ejemplo: “con todo lo que tenés…”, “con lo bonita que es la vida”, etc.).</li>

                        <li>Decile que estás dispuestx a escuchar lo que tiene para decir. Dale el tiempo que necesite hasta que termine de hablar.</li>

                    </ul>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Algunas cosas que podés decir y hacer</b></h4>
                        <div class="secContenido">
                            <ul>
                                <li>“Si no pudiste encontrar una solución, no quiere decir que no la haya, sino que ahora te cuesta verla. Hay personas que te pueden ayudar a pensar alternativas: profesionales, familia o amigxs. Con el tiempo y su ayuda, vas a poder ver las cosas de una forma distinta”.</li>
                                <li>Recordale que aunque ahora no se siente así, las cosas cambian. Este malestar intenso va a disminuir. VA A PASAR. EL SUICIDIO ES ALGO PERMANENTE ANTE ESTADOS DE CRISIS QUE SON TEMPORALES.</li>
                                <li>Evitar el consumo de alcohol o drogas, porque solamente va a empeorar las cosas</li>
                                <li>Recordale que hablar siempre lx va a aliviar</li>
                                <li>Sugerile que se descargue la APP Tranqui para que pueda tener la información necesaria y saber cómo ayudarlx.</li>
                                <li>Utilizá el plan de seguridad</li>
                                <li>Quitar cualquier medio que pueda usar para hacerse daño.</li>
                                <li>Nunca prometas secreto, es importante que compartas la situación y busques ayuda con otras personas cercanas. En estos casos no hay que actuar solx, sino intentar armar una red de apoyo.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Cuando tiene pensamientos suicidas</b></h4>
                        <div class="secContenido">
                            <ul>
                                <li>Tomarse en serio cualquier manifestación, amenaza o sospecha de conducta suicida.</li>
                                <li>Valorar el riesgo, en base a la información sobre los factores de riesgo y el análisis de la situación concreta.</li>
                                <li>En estas conversaciones tener en cuenta: cómo se siente, qué ideas suicidas tiene, si tiene un plan, si ha escrito alguna nota, etc. Toda esta información es muy valiosa para valorar la gravedad del riesgo suicida: cuantas más respuestas tenga sobre dónde, cómo y cuándo, y más letales sean las condiciones del plan, más riesgo suicida, sobre todo si existe algún antecedente previo.</li>
                                <li>Mostrar esperanza y posibilidades de superación de la situación con la ayuda oportuna.</li>
                                <li>Retirar todo lo que pueda usar para autolesionarse.</li>
                                <li>Controlar el acceso a la medicación, así como el consumo (por exceso o defecto) de la receta.</li>
                                <li>Buscar ayuda profesional: servicios de emergencias, hospital, centro de atención primaria o de salud mental. Tener siempre a mano los medios de contacto con todos ellos.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Después de un intento de suicidio</b></h4>
                        <div class="secContenido">
                            <div class="seccion">
                                <h4 class="icon-plus"><b>En el hospital</b></h4>
                                <div class="secContenido">
                                <ul>
                                    <li>Proporcionar toda la información posible a los profesionales de salud, sin ocultar datos por posibles prejuicios hacia la conducta suicida. Esta información puede referirse a: intentos suicidas previos, antecedentes suicidas familiares, posibles trastornos mentales y sus tratamientos actuales, información sobre las circunstancias del intento, etc.</li>
                                    <li>Aceptar lo ocurrido, no culpabilizar por haber cometido el acto suicida. Tratar el hecho de manera directa y empática.</li>
                                    <li>No dramatizar ni minimizar la situación generada. Es importante que traten de mantenerse tranquilos.</li>
                                    <li>Analizar y abordar en familia las posibles causas, soluciones y roles entre los diferentes miembros y minimizar así posibles repeticiones futuras. No culpabilizar.</li>
                                </ul>
                                </div>
                            </div>
                            <div class="seccion">
                                <h4 class="icon-plus"><b>Al alta del hospital</b></h4>
                                <div class="secContenido">
                                <ul>
                                    <li>Conocer el proceso que se ha seguido hasta el alta y las condiciones en las que el paciente abandona el hospital.</li>
                                    <li>Acordar con los profesionales de salud qué deben hacer y qué cosas deben evitar una vez luego del alta.</li>
                                    <li>Saber el plan de tratamiento y la forma de colaborar en él.</li>
                                    <li>Informarse sobre los recursos de atención disponibles tras el alta.</li>
                                </ul>
                                </div>
                            </div>
                            <div class="seccion">
                                <h4 class="icon-plus"><b>De regreso a casa</b></h4>
                                <div class="secContenido">
                                <ul>
                                    <li>Minimizar el acceso a medios que puedan suponer un riesgo de autolesión.</li>
                                    <li>No culpabilizar ni represaliar. No humillar o menospreciar.</li>
                                    <li>Poner en práctica las acciones recomendadas por los profesionales de salud.</li>
                                    <li>Ponerse a disposición del familiar para la ayuda que pueda necesitar en su proceso de recuperación en general y en su Plan de  Seguridad en particular.</li>
                                    <li>Ir poco a poco. No esperar soluciones mágicas. Es necesario mantener las acciones preventivas en el tiempo.</li>
                                    <li>Facilitar tareas y actividades, apoyo en el retorno al trabajo o la escuela y en la recuperación de la vida social.</li>
                                    <li>No subestimar el riesgo de suicidio pero tampoco sobreestimarlo ni vivir pendiente de él. Intentar llevar una vida lo más normalizada posible.</li>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="description" style={{marginTop: "20px"}}>
                        Todo esto provoca una gran tensión y desgaste físico, psicológico y emocional en las personas 
                        implicadas. No pienses que sos la única persona que puede ayudar o que mejor lo puede hacer. 
                        Es importante que te cuides, repartir esfuerzos y mantener el espacio vital propio. En caso 
                        de ser necesario, vos también podés  para pedir atención ayuda.
                    </p>
                </div>
                
                <div className="card formTextItem">
                    <h1>¿Cómo me cuido yo? - Mi plan de seguridad</h1>
                    <p className="description">
                        El objetivo del Plan de Seguridad es ayudar a la persona a superar la crisis. Para poder hacerlo,
                        se identifican personas, lugares, ideas o acciones que facilitan la superación de la ideación suicida
                        propia o ajena.<br/>
                        Aunque en general está dirigido a las personas con riesgo suicida, también es importante que las
                        personas como vos que estén ayudando a alguien en riesgo, elaboren su propio Plan de Seguridad
                        para identificar estrategias para manejar la situación y contactos a los que podés acudir.
                    </p>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Señales de alerta</b></h4>
                        <div class="secContenido">
                            <p>Pensá en las circunstancias que te llevaron a tener ideas suicidas o sentir ganas de hacerte daño.</p>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Actividades que puedo hacer solo para no pensar</b></h4>
                        <div class="secContenido">
                            <p>Anotá actividades que podés hacer solx y te sirven para distraerte cuando te sentís mal, para disminuir el malestar, o tranquilizarte. Puede ser alguna actividad física, salir a pasear al aire libre, escuchar música, jugar algún juego, ordenar, etc.</p>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Con quiénes puedo hablar para distraerme</b></h4>
                        <div class="secContenido">
                            <p>Identificá cuáles son esas personas de tu entorno que te pueden ayudar a distraerte cuando te sentís mal.</p>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Con quiénes puedo hablar de lo que me pasa</b></h4>
                        <div class="secContenido">
                            <p>Anotá las personas de confianza –profesionales, familiares, amigxs- con las que podés hablar honestamente de lo que te está pasando en el momento de crisis. Es importante que les avises que los vas a llamar para que te ayuden en esta situación.</p>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Listado de números de asistencia en mi ciudad</b></h4>
                        <div class="secContenido">
                            <p>
                                Armá el listado de los números de emergencia a los que podés llamar en caso que 
                                los pasos anteriores no hayan servido para manejar la crisis. <br/>
                                Para ver listado de dispositivos de atención de salud mental en Gral. Pueyrredón, 
                                entra a la sección de "Más Información".
                            </p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}